<template>
    <v-card flat class="mt-3 pa-1">
        <v-form ref="form">
            <v-layout row wrap>
                <v-flex xs12 md6>
                    <v-text-field
                            class="pa-3"
                            v-model="name"
                            label="Nosaukums"
                            color="deep-purple accent-3"
                            :rules="formRules"
                            required
                    ></v-text-field>
                </v-flex>

                <v-flex xs12 md6>
                    <v-text-field
                            class="pa-3"
                            v-model="regNr"
                            label="Reģistrācijas numurs"
                            color="deep-purple accent-3"
                    ></v-text-field>
                </v-flex>

                <v-flex xs12>
                    <v-text-field
                            class="pa-3"
                            v-model="address"
                            label="Adrese"
                            color="deep-purple accent-3"
                    ></v-text-field>
                </v-flex>
            </v-layout>

            <v-layout row wrap>
                <v-flex xs12 class="mb-3">
                    <div class="text-xs-center text-md-right">
                        <v-btn small flat @click="hideModal" dark color="deep-orange lighten-1">
                            <v-icon dark left>block</v-icon>Atcelt</v-btn>
                        <v-btn small flat @click="submit" dark color="green accent-4">Pievienot
                            <v-icon dark right>check_circle</v-icon>
                        </v-btn>
                    </div>
                </v-flex>
            </v-layout>
        </v-form>
    </v-card>

</template>

<script>

    export default {
        name: "add-company-modal",
        data: () => ({
            name: '',
            address: '',
            regNr: '',
            formRules: [
                v => !!v || 'Šis lauks ir obligāts',
            ],
        }),
        methods: {
            hideModal(){
                this.$store.dispatch('hideCompanyModal')
            },
            submit() {
                this.$Progress.start()
                if (this.$refs.form.validate()) {
                    this.$store.dispatch('createNewCompanyFromModal', {
                        name: this.name,
                        address: this.address,
                        reg_nr: this.regNr,
                    })
                } else {
                    this.$Progress.fail()
                }
            }
        }
    }
</script>

<style scoped>

</style>